export default __webpack_public_path__ + "static/media/Aura-Egg__02.12d9d693.png";